// extracted by mini-css-extract-plugin
export default {"container":"Notifications_container__1mIgk","header":"Notifications_header__T8QAj","empty":"Notifications_empty__jAXwQ"};